// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import {
  FulfillmentOrder,
  fulfillmentOrderSchema,
} from '@/fulfillment/api/types';
import { z } from 'zod';

/**
 * Schema for validating the response from the resync fulfillment order API endpoint.
 */
const resyncFulfillmentOrderResponseSchema = z.object({
  data: fulfillmentOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Re-fetches a 3PL-bound fulfillment order from the provider and reprocesses it,
 * regardless of its current status.
 *
 * @param fulfillmentKey - The key of the fulfillment order to resync
 * @returns The reprocessed fulfillment order
 */
export async function resyncFulfillmentOrder(
  fulfillmentKey: string
): Promise<FulfillmentOrder> {
  const url = `/v1/fulfillment/${fulfillmentKey}/resync`;
  const response = await api.post(url, {});

  const { data } = await parseResponse(
    resyncFulfillmentOrderResponseSchema,
    response.data,
    {
      schemaName: 'ResyncFulfillmentOrder',
      endpoint: url,
    }
  );
  return data;
}
